// Copyright (c) 2017 Deere & Company

import State, {getDefaultState} from '../state';
import SearchFilters from '../../../shared/state/search-filters';
import actions from '../../actions-list';

const updateFilterBy = (state, action) =>
    SearchFilters.update(state, {
        filterBy: {
            $set: action.data
        }
    });

const updateSortBy = (state, action) =>
    SearchFilters.update(state, {
        sortBy: {
            $set: action.data
        }
    });

const updateSortDirection = (state, action) =>
    SearchFilters.update(state, {
        sortDirection: {
            $set: action.data
        }
    });

export default (state = getDefaultState().searchFilters, action) => {

    const actionTypes = {
        [actions.UPDATE_RGA_SEARCH_LIST_FILTER_BY]: updateFilterBy,
        [actions.UPDATE_RGA_SEARCH_LIST_SORT_BY]: updateSortBy,
        [actions.UPDATE_RGA_SEARCH_LIST_SORT_DIRECTION]: updateSortDirection
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action, State) :
        state;

};



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/reducers/search-filters.js